import { Navigate } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import DashboardAppPage from '../pages/DashboardAppPage';
import Transaction from '../components/Transaction/Transaction';
import DailyStats from '../components/DailyStats/DailyStats';
import TgTransaction from '../components/TgTransaction/TgTransaction';
import AuthGuard from '../components/auth/guards/AuthGuard';

// Phase 5: Dashboard routes are guarded at layout level.
export const protectedRoutes = [
  {
    path: '/dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard/app" replace /> },
      { path: 'app', element: <DashboardAppPage /> },
      { path: 'transaction', element: <Transaction /> },
      { path: 'voice-ai-daily-stats', element: <DailyStats /> },
      { path: 'tg-transaction', element: <TgTransaction /> },
    ],
  },
  {
    path: '/',
    element: <Navigate to="/dashboard/app" replace />,
  },
];
